import { useState, useReducer, useEffect } from "react";
import { useSelector } from "react-redux";
import { Doughnut, Bar } from "react-chartjs-2";
import { Chart as ChartJS, registerables } from 'chart.js';
import dashboardReducer from "../../../reducers/dashboard";
import * as actions from "../../../actions/dashboard";

ChartJS.register(...registerables);


const initialState = {
  railGridData: [],
  peopleList: null,
  tiersList: null,
  peopleList: [],
};

const GraphView = (props) => {
  const { tierId, siteUid } = props;

  const isLightMode = useSelector((state) => state.theme.lightMode);

  const [doughnut, setDoughnut] = useState(null);
  const [stackedOne, setStackedOne] = useState(null);
  const [stackedTwo, setStackedTwo] = useState(null);
  const [stackedThree, setStackedThree] = useState(null);
  const [totals, setTotals] = useState(null);

  const [state, dispatch] = useReducer(dashboardReducer, initialState);

  const sqdcp = [
    "Safety",
    "Quality",
    "Delivery",
    "Inventory",
    "Cost",
    "People",
  ];

  const stat = ["Not Started", "In Progress", "Completed"];
  const priority = ["High", "Medium", "Low"];
  const colors = ["#dedede", "#1ca8dd", "#08C33C"];
  const options = {
    plugins: {
      title: {
        display: true,
        text: "",
      },
      legend: {
        display: false,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        stacked: true,
        ticks: {
          fontColor: "#fff",
          color: "#fff",
        },
      },
      y: {
        stacked: true,
        ticks: {
          fontColor: "#fff",
          color: "#fff",
        },
      },
    },
  };

  useEffect(() => {
    let siteInfo = siteUid ? `&siteId=${siteUid}` : "";

    actions.fetchUsers(dispatch, `tierId=${tierId}` + siteInfo);

    if (siteUid) actions.fetchTiersList(dispatch, siteUid);
    actions.fetchRailGridData(dispatch, tierId + siteInfo);
  }, []);

  useEffect(() => {
    if (state.railGridData.length && !doughnut) {
      let notStarted = 0;
      let inProgress = 0;
      let completed = 0;
      let sqdcpVal = {
        ns: [0, 0, 0, 0, 0, 0],
        ip: [0, 0, 0, 0, 0, 0],
        cmp: [0, 0, 0, 0, 0, 0],
      };
      let priorities = {
        ns: [0, 0, 0],
        ip: [0, 0, 0],
        cmp: [0, 0, 0],
      };

      let people = {};

      let peopleObj = {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: "#dedede",
            borderWidth: 1,
            barThickness: 10,
            barPercentage: 0.5,
            categoryPercentage: 0.1,
          },
          {
            data: [],
            backgroundColor: "#1ca8dd",
            borderWidth: 1,
            barThickness: 10,
            barPercentage: 0.5,
            categoryPercentage: 0.1,
          },
          {
            data: [],
            backgroundColor: "#08C33C",
            borderWidth: 1,
            barThickness: 10,
            barPercentage: 0.5,
            categoryPercentage: 0.1,
          },
        ],
      };

      for (let i = 0; i < state.railGridData.length; i++) {
        let owner = state.railGridData[i].ownerName;
        if (!people[owner != null && owner]) {
          people[owner] = {
            ns: 0,
            ip: 0,
            cmp: 0,
          };
        }
        switch (state.railGridData[i].status) {
          case "Not Started": {
            notStarted++;
            people[owner].ns++;
            switch (state.railGridData[i].sqdcp) {
              case "Safety":
                sqdcpVal.ns[0]++;
                break;
              case "Quality":
                sqdcpVal.ns[1]++;
                break;
              case "Delivery":
                sqdcpVal.ns[2]++;
                break;
              case "Inventory":
                sqdcpVal.ns[3]++;
                break;
              case "Cost":
                sqdcpVal.ns[4]++;
                break;
              case "People":
                sqdcpVal.ns[5]++;
                break;
            }
            switch (state.railGridData[i].priority) {
              case "High":
                priorities.ns[0]++;
                break;
              case "Medium":
                priorities.ns[1]++;
                break;
              case "Low":
                priorities.ns[2]++;
                break;
            }
            break;
          }
          case "In Progress": {
            inProgress++;
            people[owner].ip++;
            switch (state.railGridData[i].sqdcp) {
              case "Safety":
                sqdcpVal.ip[0]++;
                break;
              case "Quality":
                sqdcpVal.ip[1]++;
                break;
              case "Delivery":
                sqdcpVal.ip[2]++;
                break;
              case "Inventory":
                sqdcpVal.ip[3]++;
                break;
              case "Cost":
                sqdcpVal.ip[4]++;
                break;
              case "People":
                sqdcpVal.ip[5]++;
                break;
            }
            switch (state.railGridData[i].priority) {
              case "High":
                priorities.ip[0]++;
                break;
              case "Medium":
                priorities.ip[1]++;
                break;
              case "Low":
                priorities.ip[2]++;
                break;
            }
            break;
          }
          case "Completed": {
            completed++;
            people[owner].cmp++;
            switch (state.railGridData[i].sqdcp) {
              case "Safety":
                sqdcpVal.cmp[0]++;
                break;
              case "Quality":
                sqdcpVal.cmp[1]++;
                break;
              case "Delivery":
                sqdcpVal.cmp[2]++;
                break;
              case "Inventory":
                sqdcpVal.cmp[3]++;
                break;
              case "Cost":
                sqdcpVal.cmp[4]++;
                break;
              case "People":
                sqdcpVal.cmp[5]++;
                break;
            }
            switch (state.railGridData[i].priority) {
              case "High":
                priorities.cmp[0]++;
                break;
              case "Medium":
                priorities.cmp[1]++;
                break;
              case "Low":
                priorities.cmp[2]++;
                break;
            }
            break;
          }
          default:
            console.log("");
        }
      }
      setTotals([notStarted, inProgress, completed || 0]);
      Object.keys(people).forEach((val) => {
        if (val && val != "null") {
          peopleObj.labels.push(val);
          peopleObj.datasets[0].data.push(people[val].ns);
          peopleObj.datasets[1].data.push(people[val].ip);
          peopleObj.datasets[2].data.push(people[val].cmp);
        }
      });
      setDoughnut({
        labels: stat,
        datasets: [
          {
            label: "test",
            data: [notStarted, inProgress, completed || 0],
            backgroundColor: ["#dedede", "#1ca8dd", "#08C33C"],
            borderWidth: 1,
            borderColor: "#000",
          },
        ],

        options: {
          plugins: {
            legend: {
              display: true,
              position: "bottom",
            },
          },
        },
      });
      let stacked = {
        labels: sqdcp,
        datasets: [
          {
            data: sqdcpVal.ns,
            borderWidth: 1,
            backgroundColor: "#dedede",
            barThickness: 10,
            borderColor: "#000",
          },
          {
            data: sqdcpVal.ip,
            borderWidth: 1,
            backgroundColor: "#1ca8dd",
            barThickness: 10,
            borderColor: "#000",
          },
          {
            data: sqdcpVal.cmp,
            borderWidth: 1,
            backgroundColor: "#08C33C",
            barThickness: 10,
            borderColor: "#000",
          },
        ],
      };
      setStackedOne(stacked);
      let stacked1 = {
        labels: priority,
        datasets: [
          {
            data: priorities.ns,
            borderWidth: 1,
            backgroundColor: "#dedede",
            barThickness: 10,
            borderColor: "#000",
          },
          {
            data: priorities.ip,
            borderWidth: 1,
            backgroundColor: "#1ca8dd",
            barThickness: 10,
            borderColor: "#000",
          },
          {
            data: priorities.cmp,
            borderWidth: 1,
            backgroundColor: "#08C33C",
            barThickness: 10,
            borderColor: "#000",
          },
        ],
      };
      setStackedTwo(stacked1);
      setStackedThree(peopleObj);
    }
  }, [state.railGridData]);

  return (
    <div>
      <div
        className="graph-container"
        style={{ backgroundColor: isLightMode && "#d3d3d3" }}
      >
        {(doughnut || "") && (
          <div style={{ width: "25%", marginLeft: "10px" }}>
            <div className="graph-card-header">Status</div>
            <div
              className="graph-card-body"
              style={{ backgroundColor: isLightMode && "#a9a9a9" }}
            >
              <div style={{ width: "70%", position: "relative" }}>
                <div className="graph-center-text">
                  <span>{totals[0] + totals[1]}</span>
                  <span>Tasks Left</span>
                </div>
                <Doughnut
                  options={{
                    cutout: 85,
                    plugins: {
                      legend: {
                        position: "bottom",
                        display: false,
                      },
                    },
                  }}
                  data={doughnut}
                />
              </div>
              <div
                className="d-flex"
                style={{ flexDirection: "column", alignItems: "flex-start" }}
              >
                {stat.map((val, index) => (
                  <div
                    className="d-flex"
                    style={{
                      marginTop: "15px",
                      justifyContent: "space-between",
                    }}
                    key={index}
                  >
                    <div
                      className="rounded"
                      style={{
                        backgroundColor: colors[index],
                        height: "20px",
                        width: "20px",
                        borderRadius: "50%",
                      }}
                    ></div>
                    <div style={{ margin: "0 15px" }}>{val}</div>
                    <div> {totals[index]}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
        {(stackedOne || "") && (
          <div style={{ width: "36%" }}>
            <div className="graph-card-header">Bucket</div>
            <div
              className="graph-card-body canva"
              style={{ backgroundColor: isLightMode && "#a9a9a9" }}
            >
              <Bar options={options} data={stackedOne} />
            </div>
          </div>
        )}
        {(stackedTwo || "") && (
          <div style={{ width: "36%", marginRight: "10px" }}>
            <div className="graph-card-header">Priority</div>
            <div
              className="graph-card-body canva"
              style={{ backgroundColor: isLightMode && "#a9a9a9" }}
            >
              <Bar options={options} data={stackedTwo} />
            </div>
          </div>
        )}
      </div>

      {(stackedThree || "") && (
        <div
          className="graph-member-container"
          style={{ backgroundColor: isLightMode && "#d3d3d3" }}
        >
          <div
            style={{
              width: "98.7%",
              margin: "0px 10px",
            }}
          >
            <div className="graph-card-header">Members</div>
            <div
              className="graph-card-body"
              style={{
                padding: "0 20px",
                marginBottom: "10px",
                backgroundColor: isLightMode && "#a9a9a9",
              }}
            >
              <Bar
                options={{ ...options, indexAxis: "y" }}
                data={stackedThree}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GraphView;
